'use strict';

import {getLabcodeApiBaseUrl} from './labcode-api';
import {getLabcodeStaffToken} from './labcode-staff-session';

async function platformJson (path, options = {}) {
    const base = getLabcodeApiBaseUrl();
    const token = getLabcodeStaffToken();
    if (!base || !token) {
        throw new Error('Sessão ou API não disponível.');
    }
    const res = await fetch(`${base}${path}`, {
        ...options,
        headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
            ...(options.headers || {})
        }
    });
    const text = await res.text();
    let data = {};
    let jsonOk = false;
    const trimmed = text && text.trim ? text.trim() : '';
    if (trimmed.length) {
        try {
            data = JSON.parse(trimmed);
            jsonOk = true;
        } catch (e) {
            jsonOk = false;
        }
    }
    if (!res.ok) {
        if (!jsonOk && trimmed.length) {
            const expressCantMethod = /cannot\s+(post|get|put|patch|delete)\s+\//i.test(trimmed);
            const looksHtml = /^\s*</.test(trimmed) || expressCantMethod;
            if (looksHtml) {
                throw new Error(
                    'O labcode-server não reconhece este pedido. Reinicie o servidor após db:migrate ' +
                    'e confirme REACT_APP_LABCODE_API_URL.'
                );
            }
        }
        throw new Error(
            (jsonOk && data.error) || `Pedido falhou (${res.status}).`
        );
    }
    if (!jsonOk && trimmed.length) {
        throw new Error('Resposta inválida da API (esperava-se JSON).');
    }
    return data;
}

export function platformGetMe () {
    return platformJson('/platform/me');
}

export function platformGetOrganizations () {
    return platformJson('/platform/organizations');
}

export function platformCreateOrganization (body) {
    return platformJson('/platform/organizations', {
        method: 'POST',
        body: JSON.stringify(body)
    });
}

export function platformResetOrgAdminPassword (organizationId, body) {
    return platformJson(
        `/platform/organizations/${encodeURIComponent(organizationId)}/org-admin/reset-password`,
        {
            method: 'POST',
            body: JSON.stringify(body)
        }
    );
}

